import { createContext, type JSX, useContext } from 'solid-js'
import { MainModule } from '../../../features/main-module'
import { type GetKeywordListsInteractor } from '../../../features/keyword-flagging/domain/interactors/get-keyword-lists.interactor'
import { type GetKeywordListInteractor } from '../../../features/keyword-flagging/domain/interactors/get-keyword-list.interactor'
import { type SaveKeywordListInteractor } from '../../../features/keyword-flagging/domain/interactors/save-keyword-list.interactor'
import { type DeleteKeywordListInteractor } from '../../../features/keyword-flagging/domain/interactors/delete-keyword-list.interactor'

interface KeywordFlaggingContextType {
  getKeywordLists: GetKeywordListsInteractor
  getKeywordList: GetKeywordListInteractor
  saveKeywordList: SaveKeywordListInteractor
  deleteKeywordList: DeleteKeywordListInteractor
}

const KeywordFlaggingContext = createContext<KeywordFlaggingContextType>()

export const CorisKeywordFlaggingProvider = (props: { children: JSX.Element }): JSX.Element => {
  const component = MainModule.getKeywordFlaggingComponent()

  const value: KeywordFlaggingContextType = {
    getKeywordLists: component.provideGetKeywordLists(),
    getKeywordList: component.provideGetKeywordList(),
    saveKeywordList: component.provideSaveKeywordList(),
    deleteKeywordList: component.provideDeleteKeywordList()
  }

  return <KeywordFlaggingContext.Provider value={value}>{props.children}</KeywordFlaggingContext.Provider>
}

export const useKeywordFlagging = (): KeywordFlaggingContextType => {
  const context = useContext(KeywordFlaggingContext)
  if (!context) {
    throw new Error('useKeywordFlagging must be used inside a CorisKeywordFlaggingProvider')
  }
  return context
}
